export default {
	settings_layout_group_search: 'Search',
	settings_layout_spotlight_search_caption:
		'Modern search bar with keyboard shortcut (⌘K), quick actions and command palette. When disabled, the classic inline search is used.',
	settings_layout_spotlight_search_label: 'Spotlight Search',
	spotlight_action_dark_mode: 'Enable Dark Mode',
	spotlight_action_layout_settings: 'Layout Settings',
	spotlight_action_light_mode: 'Enable Light Mode',
	spotlight_action_notification_settings: 'Notifications',
	spotlight_action_theme_settings: 'Theme Settings',
	spotlight_actions: 'Quick Actions',
	spotlight_active_favorites_clear_all: 'Clear all',
	spotlight_active_favorites_label: 'Active favorites',
	spotlight_active_favorites_more_aria: 'Show more active favorites',
	spotlight_back: 'back',
	spotlight_clear_all_tooltip: 'Reset input',
	spotlight_close: 'close',
	spotlight_favorites: 'Favorites',
	spotlight_favorites_remove_chip: 'Remove favorite',
	spotlight_module_all: 'All modules',
	spotlight_module_selector_aria: 'Select search scope',
	spotlight_navigate: 'Navigation',
	spotlight_navigate_hint: 'navigate',
	spotlight_press_enter_to_search: 'Press ↵ to choose a module to search in',
	spotlight_recent: 'Recent Searches',
	spotlight_recent_in_module_tooltip: 'Last searched in {module} — click to switch scope',
	spotlight_recent_other_modules: '+{count} other modules',
	spotlight_remove: 'Remove',
	spotlight_search_for_query: 'Search for "{searchQuery}"',
	spotlight_search_in: 'Search in...',
	spotlight_search_in_module: 'Search "{searchQuery}" in {module}',
	spotlight_search_placeholder: 'Search...',
	spotlight_select: 'select',
	spotlight_tab_toggle_scope: 'switch scope',
	spotlight_where_to_search: 'Where do you want to search for "{searchQuery}"?',
};
